import { render, staticRenderFns } from "./CoreDialog.vue?vue&type=template&id=75f4efb8&scoped=true&"
import script from "./CoreDialog.vue?vue&type=script&lang=ts&setup=true&"
export * from "./CoreDialog.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./CoreDialog.vue?vue&type=style&index=0&id=75f4efb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f4efb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75f4efb8')) {
      api.createRecord('75f4efb8', component.options)
    } else {
      api.reload('75f4efb8', component.options)
    }
    module.hot.accept("./CoreDialog.vue?vue&type=template&id=75f4efb8&scoped=true&", function () {
      api.rerender('75f4efb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/core/CoreDialog/CoreDialog.vue"
export default component.exports